<template>
  <div class="table-space">
    <div class="table-header">
      <div class="add-button">
        <a-button size="small" type="primary" icon="plus"
                  @click="showAddVolunteerModal">添加志愿者</a-button>
      </div>
<!--      <div class="search-input">-->
<!--        <a-input-search-->
<!--          size="small"-->
<!--          placeholder="input search text"-->
<!--          style="width: 200px"-->
<!--          @search="onSearch"></a-input-search>-->
<!--      </div>-->
      <div class="clear"></div>
    </div>
    <div class="table-content">
      <a-table :columns="columns"
               :dataSource="volunteers"
               :pagination="false"
               :loading="loading"
               :scroll="{ x: 1000 }"
               :rowKey="record => record.id">
        <template slot="serviceHours" slot-scope="text">
          <span href="javascript:;">{{text}} h</span>
        </template>
        <span slot="action" slot-scope="record">
           <a href="javascript:;"
              v-on:click="toVolunteerDetail(record.key)"><a-icon type="eye" /></a>
           <a-divider type="vertical" />
           <a href="javascript:;"
              v-on:click="showEditVolunteerModal(record.key)"><a-icon type="edit" /></a>
           <a-divider type="vertical" />
           <a href="javascript:;"
              v-on:click="deleteVolunteer(record.id)"><a-icon type="delete" /></a>
         </span>
      </a-table>
    </div>
<!--    <div class="table-footer">-->
<!--      <a-locale-provider :locale="zhCN">-->
<!--        <a-pagination :total="total"-->
<!--                      :showTotal="total => `共 ${total} 条`"-->
<!--                      :pageSize='pageSize'-->
<!--                      :defaultCurrent="1"-->
<!--                      @showSizeChange="onChangePageSizeChange"-->
<!--                      @change="onChange"-->
<!--                      size="small"-->
<!--                      showQuickJumper-->
<!--                      showSizeChanger/>-->
<!--      </a-locale-provider>-->
<!--      <div class="clear"></div>-->
<!--    </div>-->
    <a-modal
      title="添加志愿者"
      :visible="addVolunteerVisible"
      @ok="handleAddVolunteerOk"
      :confirmLoading="confirmLoading"
      @cancel="handleAddVolunteerCancel"
    >
      <a-form
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item v-bind="formItemLayout">
          <span slot="label">名字</span>
          <a-input v-decorator="['name',
            {
              rules: [{ required: true, message: '请输入的名字!'}],
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="加入时间">
          <a-date-picker @change="changeDate"
                         style="width: 100%" placeholder="选择加入时间" v-decorator="['joinDate',
            {
              rules: [{ required: true, message: '请选择加入时间!'}],
            }]" />
        </a-form-item>
<!--        <a-form-item v-bind="formItemLayout">-->
<!--          <span slot="label">登录ID</span>-->
<!--          <a-input v-decorator="['id',-->
<!--            {-->
<!--              rules: [{ required: true, message: '请输入你的登录id!', whitespace: true }]-->
<!--            }-->
<!--           ]"/>-->
<!--        </a-form-item>-->
        <a-form-item v-bind="formItemLayout">
          <span slot="label">工作单位</span>
          <a-input v-decorator="['company',
            {
              rules: [{ required: false, }]
            }
           ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="邮箱">
          <a-input v-decorator="['email',
          {
            rules: [{
              type: 'email', message: '输入的邮箱无效!',
            }, {
              required: true, message: '请输入邮箱!',
            }]
          }
        ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="手机">
          <a-input v-decorator="['mobile',
          {
            rules: [{
              required: true, message: '请输入手机号!',
            }]
          }
        ]"/>
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span slot="label">微信</span>
          <a-input v-decorator="['wechatId',
            {
              rules: [{ required: true, message: '请输入你的微信号!', whitespace: true }]
            }
           ]"/>
        </a-form-item>
      </a-form>
    </a-modal>
      <a-modal
        title="编辑志愿者"
        :visible="editVolunteerVisible"
        @ok="handleEditVolunteerOk"
        :confirmLoading="confirmLoading"
        @cancel="handleEditVolunteerCancel"
      >
        <a-form
          :form="editForm"
          @submit="editSubmit"
        >
          <a-form-item v-bind="formItemLayout">
            <span slot="label">名字</span>
            <a-input v-decorator="['name',
            {initialValue: tempVolunteer.name,
              rules: [{ required: true, message: '请输入的名字!'}],
            }
           ]"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="加入时间">
            <a-date-picker @change="changeDate"
                           style="width: 100%" placeholder="选择加入时间" v-decorator="['joinDate',
                           {initialValue: moment(tempVolunteer.joinDate, dateFormat)}
            ]"></a-date-picker>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">工作单位</span>
            <a-input v-decorator="['company',
            {initialValue: tempVolunteer.company,
              rules: [{ required: false, }]
            }
           ]"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="邮箱">
            <a-input v-decorator="['email',
          {initialValue: tempVolunteer.email,
            rules: [{
              type: 'email', message: '输入的邮箱无效!',
            }, {
              required: true, message: '请输入邮箱!',
            }]
          }
        ]"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="手机">
            <a-input v-decorator="['mobile',
          {initialValue: tempVolunteer.mobile,
            rules: [{
              required: true, message: '请输入手机号!',
            }]
          }
        ]"/>
          </a-form-item>
          <a-form-item v-bind="formItemLayout">
            <span slot="label">微信</span>
            <a-input v-decorator="['wechatId',
            {initialValue: tempVolunteer.wechatId,
              rules: [{ required: true, message: '请输入你的微信号!', whitespace: true }]
            }
           ]"/>
          </a-form-item>
        </a-form>
    </a-modal>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import store from '../store';

const columns = [{
  dataIndex: 'name',
  key: 'name',
  // slots: { title: '姓名' },
  // scopedSlots: { customRender: 'customTitle' },
  title: '姓名',
  fixed: 'left',
  // width: 300,
  // className: 'week-num-col',
},
{
  title: '加入时间',
  dataIndex: 'joinDate',
  key: 'joinDate',
  // width: '200px',
  // className: 'week-num-col',
},
{
  title: '服务时长',
  dataIndex: 'serviceHours',
  key: 'serviceHours',
  className: 'column-service-hours',
  scopedSlots: { customRender: 'serviceHours' },
},
{
  title: '工作单位',
  dataIndex: 'company',
  key: 'company',
  // className: 'week-num-col',
},
{
  title: '手机',
  dataIndex: 'mobile',
  key: 'mobile',
  // className: 'week-num-col',
},
{
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' },
  // className: 'week-num-col',
}];
export default {
  name: 'User-manage',
  data() {
    return {
      initialValue1: ['admin', 'teacher'],
      tempUser: {},
      total: 0,
      users: [],
      columns,
      zhCN,
      tempVolunteer: '',
      dateString: '',
      volunteers: [],
      pageSize: 10,
      loading: true,
      addVolunteerVisible: false,
      editVolunteerVisible: false,
      confirmLoading: false,
      confirmDirty: false,
      autoCompleteResult: [],
      dateFormat: 'YYYY-MM-DD',
      width: 1,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0,
          },
          sm: {
            span: 16,
            offset: 8,
          },
        },
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.editForm = this.$form.createForm(this);
  },
  created() {
    this.hasVolunteerRole();
    // this.getUsersByPage(0, 10);
    this.createTempUser();
    this.getAllVolunteers();
  },
  methods: {
    moment,
    createTempUser() {
      this.tempUser.name = '1dsfsjd';
      this.tempUser.id = '测试Id';
      this.tempUser.mobile = '测试手机';
      this.tempUser.email = '测试邮箱';
    },
    async getAllVolunteers() {
      await this.axios({
        method: 'get',
        url: '/service/mgt/volunteer/getAll',
      }).then((response) => {
        if (response.data.code === 0) {
          const tempVolunteers = response.data.data;
          for (let i = 0; i < tempVolunteers.length; i += 1) {
            // const key = 'key';
            const tempVolunteer = tempVolunteers[i];
            tempVolunteer.key = i;
            this.volunteers.push(tempVolunteer);
          }
          this.loading = false;
        } else {
          this.$message.error(response.data.msg);
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误');
      });
    },
    deleteVolunteer(id) {
      const that = this;
      this.$confirm({
        title: '确定要删掉这条数据吗?',
        // iconType: 'check-circle',
        // content: '反馈已复制到剪贴板!',
        onOk() {
          that.axios.get(`/service/mgt/volunteer/delete/${id}`).then((response) => {
            if (response.data.code === 0) {
              that.$message.success('删除成功', 1);
              that.volunteers = [];
              that.getAllVolunteers();
            } else {
              that.$message.error('删除失败！');
            }
          }).catch((response) => {
            console.log(response);
            that.$message.error('服务器发生错误！');
          });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
      console.log(id);
    },
    test(index, id) {
      console.log(`hahaha:${index}`);
      console.log(`tetsts:${id}`);
    },
    onSearch(value) {
      console.log(value);
    },
    setNaIfNull(value) {
      if (value === null) {
        return 'N/A';
      }
      return value;
    },
    onChange(page, pageSize) {
      this.page = page;
      console.log(`当前页码:${this.page}`);
      this.pageSize = pageSize;
      console.log(`每页条数:${this.pageSize}`);
      this.getUsersByPage(page - 1, pageSize);
    },
    onChangePageSizeChange(current, size) {
      console.log(current);
      this.pageSize = size;
      console.log(size);
      this.getUsersByPage(current - 1, size);
    },
    showAddVolunteerModal() {
      this.form = this.$form.createForm(this);
      this.addVolunteerVisible = true;
    },
    showEditVolunteerModal(key) {
      this.tempVolunteer = this.volunteers[key];
      this.editForm = this.$form.createForm(this);
      this.dateString = null;
      this.editVolunteerVisible = true;
    },
    toVolunteerDetail(key) {
      store.state.volunteer = this.volunteers[key];
      this.$router.push('/layout/volunteer-detail');
    },
    async getVolunteerById(id) {
      await this.axios.get(`/service/feedback/${id}`).then((response) => {
        if (response.data.code === 0) {
          this.tempVolunteer = response.data.data;
        } else {
          this.$message.error('获取失败！');
        }
      }).catch((response) => {
        console.log(response);
        this.$message.error('服务器发生错误！');
      });
    },
    handleAddVolunteerOk() {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign
          values.joinDate = this.dateString;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: '/service/mgt/volunteer/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('志愿者添加成功', 1);
              // this.$router.push('/layout/book-card');

              this.addVolunteerVisible = false;
              this.volunteers = [];
              this.getAllVolunteers();
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    handleEditVolunteerOk() {
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // eslint-disable-next-line no-param-reassign,max-len
          values.joinDate = this.dateString === null ? this.tempVolunteer.joinDate : this.dateString;
          // eslint-disable-next-line no-param-reassign
          values.id = this.tempVolunteer.id;
          console.log('Received values of form: ', values);
          this.axios({
            method: 'post',
            url: '/service/mgt/volunteer/submit',
            data: values,
          }).then((response) => {
            if (response.data.code === 0) {
              this.$message.success('志愿者更新成功', 1);
              // this.$router.push('/layout/book-card');
              this.editVolunteerVisible = false;
              this.volunteers = [];
              this.getAllVolunteers();
            } else {
              this.$message.error(response.data.msg);
            }
          }).catch((response) => {
            console.log(response.data);
          });
        }
      });
    },
    hasVolunteerRole() {
      if (store.state.user.roles.indexOf('VADMIN') < 0) {
        this.$router.push('/layout/book-card');
      }
    },
    changeDate(date, dateString) {
      this.dateString = dateString;
      console.log(dateString);
    },
    handleAddVolunteerCancel() {
      console.log('Clicked cancel button');
      this.addVolunteerVisible = false;
    },
    handleEditVolunteerCancel() {
      console.log('Clicked cancel button');
      this.editVolunteerVisible = false;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    editSubmit(e) {
      e.preventDefault();
      this.editForm.validateFieldsAndScroll((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleConfirmBlur(e) {
      const { value } = e.target;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const { form } = this;
      if (value && value !== form.getFieldValue('password')) {
        callback('Two passwords that you enter is inconsistent!');
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const { form } = this;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`);
      }
      this.autoCompleteResult = autoCompleteResult;
    },
  },
};
</script>

<style scoped>
  .table-space {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
  }
  /*.table-content{*/
  /*  margin-top: 20px;*/
  /*}*/
  .add-button {
    float: left;
  }
  .search-input{
    float: right;
  }
  .table-footer {
    margin-top: 10px;
    float: right;
  }
  @media (min-width: 576px){
    .ant-col-sm-8 {
      width: 28.33333333% !important;
    }
  }
  .table-header{
    margin-top: 20px;
    height: 40px;
  }
</style>
